import { Customer } from '../types/sharedTypeImpl.ts';
import { trpc } from '../utils/trpc/trpc.ts';


interface Props {
    className?: string;
    name?: string;
    required?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    onChange?: (name: string) => void;
}

export function CustomerSelect({
    className,
    name,
    required,
    disabled,
    readOnly,
    onChange,
}: Props) {

    const { data: customers } = trpc.customers.get.useQuery(
        undefined,
        { enabled: !disabled }
    );

    const usingUnlistedCustomer = name && !customers?.find(
        (it) => it.name.toUpperCase() === name.toUpperCase()
    );
    const optionsFinal = [
        ...customers?.filter(it => it.isActive || it.name === name) ?? [],
        ...(usingUnlistedCustomer ? [{ name, isActive: true } as Customer] : [])
    ].sort((a, b) => a.name.localeCompare(b.name));


    return (
        <select
            className={className}
            style={{ pointerEvents: readOnly ? 'none' : 'auto' }}
            disabled={disabled ?? false}
            required={required}
            value={name ?? ''}
            onChange={(event) => onChange?.(event.target.value)}
        >
            <option value='' disabled hidden />
            {optionsFinal?.map((it) => (
                <option key={it.name} value={it.name}>
                    {it.name}
                </option>
            ))}
        </select>
    )
}
